var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "editor d-flex flex-column"
  }, [_c('div', {
    staticClass: "scroll-ctn"
  }, [_c('v-btn', {
    staticClass: "phone-preview-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.expandPreview
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-cellphone")])], 1), _vm.configVersion === 2 ? _c('div', [_c('div', {
    staticClass: "landing-page-header"
  }, [_vm._v(" " + _vm._s(_vm.$t('editor_landing_page_layout')) + " ")]), _c('product-informations', {
    class: {
      'mb-4': _vm.isAvailable('editor:tabs:settings'),
      'pb-0': !_vm.isAvailable('editor:tabs:settings')
    }
  })], 1) : _vm._e(), _vm.isAvailable('editor:tabs:create') && !_vm.stcTabs.length ? _c('div', {
    staticClass: "new-tab-button",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.openNewTabModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('editor_new_tab_button')) + " ")]) : _vm._e(), _vm.stcTabs.length ? _c('div', {
    staticClass: "tabs-ctn"
  }, [_c('v-tabs', {
    class: {
      'hide-selection': !_vm.isAvailable('editor:tabs:settings')
    },
    attrs: {
      "show-arrows": "mobile"
    },
    model: {
      value: _vm.activeTab,
      callback: function callback($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c('draggable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAvailable('editor:tabs:settings'),
      expression: "isAvailable('editor:tabs:settings')"
    }],
    staticClass: "v-tabs__container flex-shrink-1 flex-grow-0 v-slide-group__content v-tabs-bar__content",
    on: {
      "change": _vm.onTabChange
    },
    model: {
      value: _vm.stcTabs,
      callback: function callback($$v) {
        _vm.stcTabs = $$v;
      },
      expression: "stcTabs"
    }
  }, _vm._l(_vm.stcTabs, function (tab, index) {
    return _c('v-tab', {
      key: "tab-".concat(index),
      staticClass: "tab-name",
      attrs: {
        "href": "#tab-".concat(index)
      }
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('v-icon', {
      staticClass: "tab-icon"
    }, [_vm._v(_vm._s(tab.icon))]), _c('span', {
      staticClass: "tab-title flex-grow-1 px-7"
    }, [_vm._v(_vm._s(tab.name[_vm.defaultLanguage]))]), _c('tab-settings', {
      attrs: {
        "tabId": tab.id,
        "name": tab.name[_vm.defaultLanguage],
        "icon": tab.icon
      },
      on: {
        "delete-tab": _vm.openDeleteTabModal
      }
    })], 1)]);
  }), 1), _vm._l(_vm.stcTabs, function (tab, index) {
    return _c('v-tab-item', {
      key: "tab-".concat(index),
      staticClass: "tab-content",
      attrs: {
        "id": "tab-".concat(index)
      }
    }, [tab.type == 'cms' ? _c('cms', {
      attrs: {
        "tab-id": tab.id
      }
    }) : _vm._e(), tab.type == 'track-and-trace' ? _c('track-and-trace', {
      attrs: {
        "tab-id": tab.id
      }
    }) : _vm._e(), tab.type == 'custom-html' ? _c('custom-html', {
      attrs: {
        "tab-id": tab.id
      }
    }) : _vm._e()], 1);
  }), _vm.isAvailable('editor:tabs:create') && (_vm.stcTabs.length < 4 || _vm.isAdmin) && _vm.stcTabs.length > 0 ? _c('div', {
    staticClass: "new-tab-button",
    on: {
      "click": _vm.openNewTabModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('editor_add_new_tab_text')) + " "), _c('v-icon', {
    attrs: {
      "color": "rgba(7, 137, 178, 0.5)"
    }
  }, [_vm._v("mdi-plus-circle-outline")])], 1) : _vm._e()], 2)], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.newTabModal,
      callback: function callback($$v) {
        _vm.newTabModal = $$v;
      },
      expression: "newTabModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('editor_choose_tab_template')))]), _c('v-card-text', [_c('v-radio-group', {
    model: {
      value: _vm.newTabType,
      callback: function callback($$v) {
        _vm.newTabType = $$v;
      },
      expression: "newTabType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('editor_blank_tab_template'),
      "value": "cms"
    }
  }), this.isAvailable('editor:tabs:track-and-trace') ? _c('v-radio', {
    attrs: {
      "disabled": _vm.hasTrackAndTrace(),
      "label": _vm.$t('editor_traceability_tab_template'),
      "value": "track-and-trace"
    }
  }) : _vm._e(), _c('v-radio', {
    attrs: {
      "label": _vm.$t('editor_custom_html_tab_template'),
      "value": "custom-html"
    }
  })], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeNewTabModal
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addNewTab
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.deleteTabModal,
      callback: function callback($$v) {
        _vm.deleteTabModal = $$v;
      },
      expression: "deleteTabModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('editor_remove_tab')))]), _c('div', {
    staticClass: "font-weight-light pa-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('editor_remove_tab_description')) + " ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.deleteTabModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    on: {
      "click": _vm.deleteTab
    }
  }, [_vm._v(_vm._s(_vm.$t('delete')))])], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }